<script>
  import {onMount} from 'svelte';
  import {topicsURL, topics, debounce} from './settings';
  import Card from './Card.svelte';

  let sections = [];
  let loading = true;
  let error = false;
  let width = 0;
  let selected = 0;
  let el;

  const move = (index) => {
    selected = index;
    el.scrollTo({ top: 0, left: index * (width + 40), behavior: 'smooth' });
  };

  onMount(async () => {
    try {
      for (let i = 0, l = topics.length; i < l; i += 1) {
        const q = topics[i].queries.map(d => ({ query: d.query, keys: d.keys }));
        const response = await fetch(`${topicsURL}/?k=${JSON.stringify(q)}`);
        const data = await response.json();
        if (!data.error) {
          const keys = Object.keys(data.data.meloni);
          const tmpData = [];
          keys.forEach((k) => {
            tmpData.push({
              id: k,
              title: topics[i].queries.find(d => d.query === k)?.title || null,
              description: topics[i].queries.find(d => d.query === k)?.description || null,
              meloni: data.data.meloni[k],
              schlein: data.data.schlein[k],
              tags: topics[i].queries.find(d => d.query === k)?.keys || null,
            });
          });
          sections.push({
            id: topics[i].id,
            title: topics[i].title,
            description: topics[i].description,
            data: tmpData,
            subs: tmpData.length,
          });
        }
      }
      sections = sections.slice(0);
      loading = false;
    } catch(e) {
      console.warn(e);
      loading = false;
      error = true;
    }
  });

</script>

<div id="topics" class="{loading ? 'loading' : ''}">
  {#if error}
    <p class="error">C'è stato un problema nel caricamento dei dati, per favore riprova più tardi.</p>
  {:else}
    <div class="topics--text">
      <p>Vediamo come, in queste settimane, i nomi delle nostre protagoniste sono stati associati ad alcuni argomenti "caldi".</p>
    </div>
    <div class="topics--pagination">
      {#each sections as section, index}
        <button on:click={() => move(index)} title={section.title}>{#if selected === index}◉{:else}◎{/if}</button>
      {/each}
    </div>
    <div class="topics--charts" bind:this={el} bind:offsetWidth={width}>
      {#each sections as section}
        <Card data={section} />
      {/each}
    </div>
    <div class="topics--pagination">
      {#each sections as section, index}
        <button on:click={() => move(index)} title={section.title}>{#if selected === index}◉{:else}◎{/if}</button>
      {/each}
    </div>
  {/if}
</div>

<style>
  #topics {
    display: block;
    height: auto;
    margin: 0 20px;
    opacity: 1;
    padding: 10vh 0;
    transition: opacity .5s ease-in-out;
    width: auto;
  }
  
  #topics.loading {
    opacity: 0;
  }

  .topics--charts {
    display: flex;
    flex-wrap: nowrap;
    overflow: hidden;
  }

  .topics--pagination {
    display: block;
    margin: 20px 0;
    text-align: center;
    width: 100%;
  }

  .topics--pagination button {
    background: transparent;
    border: none;
    color: var(--dark);
    font-size: 16px;
    margin: 0 5px;
  }

  @media screen and (min-width:768px) {
    #topics {
      max-width: 960px;
    }
  }

  @media screen and (min-width:1024px) {
    #topics {
        margin: 0 auto;
    }
  }
</style>